// 任务分解
import request from '@/utils/request'

const BaseUrl = '/bizTaskDecomposition'

// /bizTaskAllocation/{id}
// 查询
export function queryById(id) {
  return request({
    url: `${BaseUrl}/${id}`,
    method: 'get',
  })
}

// 添加
export function add(data) {
  return request({
    url: `${BaseUrl}/save`,
    method: 'post',
    data
  })
}

// 删除
export function del(id) {
  return request({
    url: `${BaseUrl}/delete/${id}`,
    method: 'delete'
  })
}

// /bizTaskDecomposition/deleteBizJobContentDecomposition/{id}
// 删除工作内容
export function delForm(id) {
  return request({
    url: `${BaseUrl}/deleteBizJobContentDecomposition/${id}`,
    method: 'delete'
  })
}
// /bsProfessionalLevel/update
// 修改
export function edit(data) {
  return request({
    url: `${BaseUrl}/update`,
    method: 'put',
    data
  })
}

// 审核或者交付
export function reviewTask(data) {
  return request({
    url: `${BaseUrl}/reviewBizTaskDecomposition`,
    method: 'post',
    data
  })
}

// /bizTaskDecomposition/findProjectNodeInfo/{projectNodeId} 查询项目节点信息
export function findProjectNodeInfo(projectNodeId, projecId) {
  return request({
    url: `${BaseUrl}/findProjectNodeInfo/${projectNodeId}/${projecId}`,
    method: 'get',
  })
}
